import { Box, Container } from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import StoreIcon from "@mui/icons-material/Store";
import EmailIcon from "@mui/icons-material/Email";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { Link } from "react-router-dom";
import { useConfig } from "../../context/Config/ConfigContext";
import logo from "../../assets/img/logos/logo-grupo-monaco.jpg";
import "./Footer.css";

function Footer() {
	const { config } = useConfig();

	function scrollToSection(elementRef) {
		if (elementRef !== "") {
			window.scrollTo({
				top: (0, 0),
				behavior: "smooth",
			});
		}
	}

	return (
		<Container maxWidth="lg">
			<Box className="footerBox">
				<div className="boxFooterBrand">
					<img
						src={logo}
						alt="Logo de El Don Mayorista"
						className="footer-logo"
					/>
				</div>
				<div className="boxFooterDataContainer">
					<div className="dataItemsContainer">
						<p className="itemFooterText">
							<StoreIcon sx={{ pr: 1 }} />
							Retiros en persona. Zona Nuñez (Zona Parque Saavedra) C.A.B.A
						</p>
					</div>
					<div className="dataItemsContainer">
						<p className="itemFooterText">
							<PhoneIcon sx={{ pr: 1 }} />{" "}
							{config.footerPhoneNumbers[0].phoneNumber}
						</p>
					</div>
					<div className="dataItemsContainer">
						<p className="itemFooterText">
							<EmailIcon sx={{ pr: 1 }} /> E-mail: ventas@grupomonaco.com.ar
						</p>
					</div>
					<div className="dataItemsContainer">
						<p className="itemFooterText">
							<AccessTimeIcon sx={{ pr: 1 }} /> Horario: Lunes a Viernes de 8:30
							a 17 Hs
						</p>
					</div>

					<div className="myAccountContainer">
						<Link
							to="/user-account"
							style={{
								color: "#000000",
								textDecoration: "none",
							}}
						>
							<p className="textFooter">Mi Cuenta</p>
						</Link>
						<Link
							to="/cart"
							style={{
								color: "#000000",
								textDecoration: "none",
							}}
						>
							<p className="textFooter">Mi Carrito</p>
						</Link>
					</div>
				</div>
				<div className="boxFooterAboutUs">
					<div className="aboutUsContainer">
						{config.footerSections.map((section) => (
							<Link
								to={`/information/${section.href}`}
								key={section.idFooterSection}
								style={{ textDecoration: "none", color: "#000000" }}
							>
								<p
									className="textFooter"
									onClick={() => scrollToSection(section.idFooterSection)}
								>
									{section.title}
								</p>
							</Link>
						))}
					</div>
				</div>
				<div className="boxFooterSocialMediaAndDataFiscal">
					<div className="dataFiscalContainer">
						<a
							href="http://qr.afip.gob.ar/?qr=bH-f34b2EcqyRRjQbYQNEA,,"
							target="_F960AFIPInfo"
						>
							<img
								src="https://www.afip.gob.ar/images/f960/DATAWEB.jpg"
								alt="Data Fiscal"
								className="footer-dataFiscal"
								style={{ width: 70 }}
							/>
						</a>
					</div>
					<div className="copyrightContainer">
						<p className="textFooter">copyright 2022</p>
					</div>
				</div>
			</Box>
		</Container>
	);
}

export default Footer;
